<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Trainer Report
        <v-spacer></v-spacer>

        <div class="ml-12">
          <download-excel
              :data="selected"
              :fields="export_fields"
              name="trainerReport.xls"
              type="csv"
          >
            <v-btn
                class="teal white--text"
                color="primary"
                dark
                depressed
                small
            >
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="trainerReport.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="trainerReport.count"
          class="elevation-1"
          loading-text="Loading... please wait"
          show-select
      >

        <template v-slot:top>
          <v-layout class="p-2" row wrap>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="nameValue"
                  label="Name"
                  type="text"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="phoneValue"
                  label="Phone Number"
                  type="number"
              ></v-text-field>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-text-field
                  v-model="emailValue"
                  label="Email"
                  type="test"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:[`item.firstName`]="{ item }">
          <label for="item">{{ item.firstName }} {{ item.middleName }} {{ item.lastName }}</label>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {TrainerReportService} from "./trainer-report-service";

export default {
  data() {
    return {
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      trainerReport: [],
      headers: [
        {text: "Full Name", value: "fullName"},
        {text: "Gender", value: "gender"},
        {text: "Phone", value: "phoneNumber"},
        {text: "Email", value: "email"},
        {text: "Education Level", value: "educationalLevel.name"},
        {text: "Profession", value: "profession.name"},
        {text: "Trainer Type", value: "trainerType.name"},
        {text: "Trainer Selection Criteria", value: "trainerSelectionCriteria.name"},
        {text: "Course Name", value: "trainer_courses[0].course.courseName"},
        {text: "CEU", value: "trainer_courses[0].course.continualEducationUnit"},
        {text: "CPD Activity", value: "trainer_courses[0].program.category.name"},
        {text: "Course Completion Date", value: "trainer_courses[0].courseCompletionDate"},
      ],
      export_fields: {
        "Full Name": "fullName",
        "Gender": "gender",
        "Phone": "phoneNumber",
        "Email": "email",
        "Education Level": "educationalLevel.name",
        "Profession": "profession.name",
        "Trainer Type": "trainerType.name",
        "Trainer Selection Criteria": "trainerSelectionCriteria.name",
        "Course Name": "trainer_courses[0].course.courseName",
        "CEU": "trainer_courses[0].course.continualEducationUnit",
        "CPD Activity": "trainer_courses[0].program.category.name",
        "Course Completion Date": "trainer_courses[0].courseCompletionDate",
      },
      loading: false,
      clearable: true,
      selected: [],
      EXPERT_LEVEL: [],
      expertLevelValue: null,

      nameValue: null,
      phoneValue: null,
      emailValue: null,
    };
  },
  async beforeMount() {
    this.fetchTrainerReport();
  },
  watch: {
    options: {
      handler() {
        this.fetchTrainerReport();
      },
      deep: true,
    },
    nameValue: function (val) {
      this.nameValue = val;
      this.fetchTrainerReport();
    },
    phoneValue: function (val) {
      this.phoneValue = val;
      this.fetchTrainerReport();
    },
    emailValue: function (val) {
      this.emailValue = val;
      this.fetchTrainerReport();
    },
  },
  computed: {},
  methods: {
    async fetchTrainerReport() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '?';
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.nameValue !== null && (searchParams += '&name=' + this.nameValue);
      this.phoneValue !== null && (searchParams += '&phone=' + this.phoneValue);
      this.emailValue !== null && (searchParams += '&email=' + this.emailValue);

      const res = await TrainerReportService.getTraineeReports(searchParams);
      if (res.status === 200) {
        this.loading = false;
        this.trainerReport = res.data.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching Trainee reports, Please try Again!"
        );
      }
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
  },
};

</script>

<style scoped>
.addCard {
  background: hsla(0, 0%, 100%, 0.45);
}
</style>